import { memo, useCallback, useState } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { AdminFormRow, ConfirmationModal } from '@ui';
import { ControlledYesNoRadio } from '../../components/inputs/ControlledYesNoRadio';
import { NewOcsConsoleForm } from '../types';

type OcsConsoleMaintenanceRowProps = {
  isReadOnly?: boolean;
};

export const OcsConsoleMaintenanceRow = memo(({ isReadOnly }: OcsConsoleMaintenanceRowProps) => {
  const { control, setValue } = useFormContext<NewOcsConsoleForm>();
  const isInMaintenance = useWatch({ control, name: 'isInMaintenance' });

  const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);

  const onConfirmationModalClose = useCallback(() => {
    setConfirmationModalOpen(false);
  }, []);

  const onChangeActive = useCallback(async () => {
    setValue('isInMaintenance', !isInMaintenance);
  }, [isInMaintenance, setValue]);

  return (
    <>
      <AdminFormRow title="Maintenance" isRequired>
        <ControlledYesNoRadio
          name="isInMaintenance"
          isReadOnly={isReadOnly}
          onValueChange={() => setConfirmationModalOpen(true)}
        />
      </AdminFormRow>
      <ConfirmationModal
        title="Change OCS Console maintenance status?"
        description="Are you sure you want to change the maintenance status?"
        isOpen={confirmationModalOpen}
        onChangeActive={onChangeActive}
        onClose={onConfirmationModalClose}
      />
    </>
  );
});

OcsConsoleMaintenanceRow.displayName = 'OcsConsoleMaintenanceRow';
